<template>
  <v-card outlined tile class="ma-3 pa-0 align-start">
    <v-card tile class="d-flex justify-start"  v-if="fullView || mode=='viewer'">
      <v-card outlined tile class="pl-3 pr-3" width="250px">
        <v-chip class="ma-2" color="primary">Имя свойства</v-chip>
      </v-card>
      <v-card outlined tile class="pl-3 pr-3" width="400px">
        <v-text-field v-model="PROPERTY.PROP_NAME" dense readonly >
          <template v-slot:append v-if="mode=='editor'  && !property.PROP_ID">
            <v-icon small @click="callSelectRefProperty"> mdi-plus-circle-multiple-outline </v-icon>
          </template>
        </v-text-field>
      </v-card>
    </v-card>
    <v-card tile class="d-flex justify-start" v-if="fullView">
      <v-card outlined tile class="pl-3 pr-3" width="250px">
        <v-chip class="ma-2" color="primary">Min. значение</v-chip>
      </v-card>
      <v-card tile class="pl-3 pr-3" width="400px">
        <v-text-field v-model="PROP_MIN" dense type="number" :readonly="mode=='viewer'"/>
      </v-card>
    </v-card>
    <v-card tile class="d-flex justify-start" v-if="fullView">
      <v-card outlined tile class="pl-3 pr-3" width="250px">
        <v-chip class="ma-2" color="primary">Max. значение</v-chip>
      </v-card>
      <v-card tile class="pl-3 pr-3" width="400px">
        <v-text-field v-model="PROP_MAX" dense type="number" :readonly="mode=='viewer'"/>
      </v-card>
    </v-card>
    <v-card tile class="d-flex justify-start" v-if="fullView">
      <v-card outlined tile class="pl-3 pr-3" width="250px">
        <v-chip class="ma-2" color="primary">Коэффициент</v-chip>
      </v-card>
      <v-card outlined tile class="pl-3 pr-3" width="400px">
        <v-text-field v-model="PROP_KOEFF" type="number" dense :readonly="mode=='viewer'" />
      </v-card>
    </v-card>
    <v-card tile class="d-flex justify-start" v-if="!fullView">
      <v-card outlined tile class="pl-3 pr-3" width="250px">
        <v-chip class="ma-2" color="primary">Значение</v-chip>
      </v-card>
      <v-card outlined tile class="pl-3 pr-3" width="400px">
        <v-text-field v-model="CURR_PROP_VALUE" type="number" dense :readonly="mode=='viewer'" />
      </v-card>
    </v-card>
    <prj-select-ref-property-dialog :ref-property="PROPERTY" v-model="showSelectRefProperty" @onRefPropertyChanged="setRefProperty"></prj-select-ref-property-dialog>
  </v-card>
</template>

<script>

import PrjSelectRefPropertyDialog from '@/components/modules/projects/dialogs/prjSelectRefPropertyDialog'
export default {
  name: 'compPropertyCard',
  components: { PrjSelectRefPropertyDialog },
  props: ['property', 'mode', 'fullView'],
  data () {
    return {
      showSelectRefProperty: false
    }
  },
  computed: {
    PROP_MIN: {
      get () {
        return this.property ? this.property.PROP_MIN : ''
      },
      set (val) {
        this.$emit('onPropUpdate', { PROP_MIN: val })
      }
    },
    PROP_MAX: {
      get: function () {
        return this.property ? this.property.PROP_MAX : ''
      },
      set (val) {
        this.$emit('onPropUpdate', { PROP_MAX: val })
      }
    },
    PROP_KOEFF: {
      get: function () {
        return this.property ? this.property.PROP_KOEFF : ''
      },
      set (val) {
        this.$emit('onPropUpdate', { PROP_KOEFF: val })
      }
    },
    CURR_PROP_VALUE: {
      get: function () {
        return this.property ? this.property.CURR_PROP_VALUE : ''
      },
      set (val) {
        this.$emit('onPropUpdate', { CURR_PROP_VALUE: val })
      }
    },
    PROPERTY: {
      get: function () {
        console.log('compPropertyCard in mode ', this.mode, ' getting PROPERTY value. property param is ', this.property)
        return this.property.PROP_ID ? { PROP_ID: this.property.PROP_ID, PROP_NAME: this.property.PROP_NAME, PROP_CODE: this.property.PROP_CODE } : { }
      },
      set (val) {
        console.log('compPropertyCard in mode ', this.mode, 'setting PROPERTY value to ', val)
        this.$emit('onPropUpdate', val ? { PROP_ID: val.PROP_ID, PROP_NAME: val.PROP_NAME, PROP_CODE: val.PROP_CODE } : {})
      }
    }
  },
  methods: {
    callSelectRefProperty () {
      this.showSelectRefProperty = true
    },
    setRefProperty (val) {
      console.log('Setting Reference property to ', val)
      this.PROPERTY = val
    }
  },
  mounted () {
    console.log('compPropertyCard mounted in mode ', this.mode, ' with Property ', this.property)
  }
}
</script>
